import React from 'react'
import { useTranslate } from 'react-admin'

import { Tooltip as MuiTooltip } from '@material-ui/core'

type WrapperProps = {
  children: any
}

const Wrapper = React.forwardRef<HTMLDivElement, WrapperProps>(
  ({ children, ...others }, ref) => (
    <div ref={ref}>{React.cloneElement(children, others)}</div>
  ),
)

export const Tooltip = (props: any) => {
  const translate = useTranslate()
  const { children, title, placement = 'right', ...rest } = props

  return (
    <MuiTooltip {...rest} placement={placement} title={translate(title)}>
      <Wrapper>{children}</Wrapper>
    </MuiTooltip>
  )
}
